import { escapeHtml } from "../utils/escape";
import type { Translator } from "../i18n/resolve";

export type EmptyReason = "subscription_inactive" | "filters_too_strict" | "no_reviews_yet";

export const renderEmptyState = (reason: EmptyReason, translate: Translator): string => {
  if (reason === "subscription_inactive") return "";
  const messageKey =
    reason === "filters_too_strict" ? "emptyFiltersTooStrict" : "emptyNoReviewsYet";
  return `<p class="mbn-empty">${escapeHtml(translate(messageKey))}</p>`;
};
